import { useWatch } from 'react-hook-form';

export const useOfficeProfile = (control) => {
  const watchedValues = useWatch({
    control,
    name: [
      'officeName',
      'website',
      'dentistFirstName',
      'dentistLastName',
      'additionalContactFirstName',
      'additionalContactLastName',
      'officeType',
      'selectedSpecialty',
    ],
  });

  const formValues = {
    officeName: watchedValues[0],
    website: watchedValues[1],
    dentistFirstName: watchedValues[2],
    dentistLastName: watchedValues[3],
    additionalContactFirstName: watchedValues[4],
    additionalContactLastName: watchedValues[5],
    officeType: watchedValues[6],
    selectedSpecialty: watchedValues[7],
  };

  const isValid =
    !!formValues.officeName?.trim() &&
    !!formValues.dentistFirstName?.trim() &&
    !!formValues.dentistLastName?.trim() &&
    (!formValues.additionalContactFirstName || !!formValues.additionalContactFirstName?.trim()) &&
    (!formValues.additionalContactLastName || !!formValues.additionalContactLastName?.trim()) &&
    !!formValues.officeType?.trim() &&
    !!formValues.selectedSpecialty?.trim();

  return {
    formValues,
    isValid,
  };
};
